import { IPositionType } from 'src/generated-types'
import { IGridCage, IGridExpansionPreview, IGridExpansionStatus, IGridSide } from 'src/generated-types/grid-expansion'

export const EXPAND_COUNTS = [1, 2, 3]

export const growsColumns = (side: IGridSide) => side === IGridSide.Left || side === IGridSide.Right

export const gridBounds = (cages: IGridCage[]) => ({
  minColumn: Math.min(...cages.map(c => c.column)),
  maxColumn: Math.max(...cages.map(c => c.column)),
  minRow: Math.min(...cages.map(c => c.row)),
  maxRow: Math.max(...cages.map(c => c.row)),
})

// Cells the expansion adds, in the same grid places as the cages.
export const addedCells = (cages: IGridCage[], side: IGridSide, count: number) => {
  if (!cages.length) return []
  const { minColumn, maxColumn, minRow, maxRow } = gridBounds(cages)
  const steps = Array.from({ length: count }, (_, i) => i + 1)
  const columns = Array.from({ length: maxColumn - minColumn + 1 }, (_, i) => minColumn + i)
  const rows = Array.from({ length: maxRow - minRow + 1 }, (_, i) => minRow + i)
  switch (side) {
    case IGridSide.Left:
      return steps.flatMap(k => rows.map(row => ({ column: minColumn - k, row })))
    case IGridSide.Right:
      return steps.flatMap(k => rows.map(row => ({ column: maxColumn + k, row })))
    case IGridSide.Bottom:
      return steps.flatMap(k => columns.map(column => ({ column, row: minRow - k })))
    default:
      return steps.flatMap(k => columns.map(column => ({ column, row: maxRow + k })))
  }
}

export const addedCount = (preview: IGridExpansionPreview | undefined, type: IPositionType) =>
  preview?.added.find(a => a.type === type)?.count ?? 0

const STATUS_MESSAGE_KEY: Partial<Record<IGridExpansionStatus, string>> = {
  [IGridExpansionStatus.NotADraft]: 'revision-expand-not-a-draft',
  [IGridExpansionStatus.NotSupported]: 'revision-expand-unsupported',
  [IGridExpansionStatus.NotPlaced]: 'revision-expand-not-placed',
  [IGridExpansionStatus.NoCoordinates]: 'revision-expand-no-coordinates',
  [IGridExpansionStatus.NamesExhausted]: 'revision-expand-names-exhausted',
}

export const expansionStatusKey = (status: IGridExpansionStatus) => STATUS_MESSAGE_KEY[status]

// The edge lines chosen for replacing, after choosing move or replace for one of them.
export const withReplaced = (replaced: number[], id: number, replace: boolean) =>
  replace ? [...replaced.filter(r => r !== id), id] : replaced.filter(r => r !== id)

// Whether all edge lines are replaced, all moved, or null when mixed.
export const allReplaced = (lineIds: number[], replaced: number[]) =>
  lineIds.every(id => replaced.includes(id)) ? true : replaced.length === 0 ? false : null
